import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { fetchTermedActivations } from '../../api/contracts/contractCalls';
import type { ApiAssetInfo } from '../../api/tags/tag.types';
import { fetchAssets } from '../../api/tags/tagCalls';
import LoadingErrorState from '../../common/error/LoadingErrorState';
import type { TermedLevel } from '../../common/termedLevel/types';
import { BookingOverviewStats } from './BookingOverviewStats';
import { getBookingOverviewStatistics } from './bookingOverviewService';

interface BookingOverviewData {
    contracts: TermedLevel[];
    assets: ApiAssetInfo[];
}

export function BookingOverviewContainer() {
    const [data, setData] = useState<BookingOverviewData>();
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        let isMounted = true;
        Promise.all([fetchTermedActivations(), fetchAssets()])
            .then(([contracts, assets]) => {
                if (isMounted) {
                    setData({ contracts, assets });
                }
            })
            .catch(() => {
                if (isMounted) {
                    setHasError(true);
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    if (hasError) {
        return <LoadingErrorState />;
    }

    if (!data) {
        return <Spinner text={<FormattedMessage id='marketplace.loading' />} isInverse={false} />;
    }

    return <BookingOverviewStats statistics={getBookingOverviewStatistics(data.contracts, data.assets)} />;
}
